<template>
  <v-dialog
    v-model="show"
    :fullscreen="$vuetify.breakpoint.smAndDown"
    persistent
    hide-overlay
    transition="dialog-bottom-transition"
    scrollable
    max-width="80%">
    <v-card>
      <v-toolbar flat dark color="primary" style="max-height: 65px;">
        <v-btn icon dark class="hidden-md-and-up" @click="$emit('close')">
          <v-icon>close</v-icon>
        </v-btn>
        <v-toolbar-title>Neuer Mitarbeiter</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-toolbar-items>
          <v-btn dark text :disabled="!userForm.valid" v-show="$vuetify.breakpoint.sm" @click.native="createUser">
            Mitarbeiter anlegen
            <v-icon right>save</v-icon>
          </v-btn>
          <v-btn dark icon :disabled="!userForm.valid" v-show="$vuetify.breakpoint.xs" @click.native="createUser">
            <v-icon v-show="$vuetify.breakpoint.smAndDown">save</v-icon>
          </v-btn>
        </v-toolbar-items>
      </v-toolbar>

      <v-form ref="form" v-model="userForm.valid">
        <v-container grid-list-md>
          <v-layout wrap>
            <v-flex xs12>
              <v-text-field
                label="E-Mail"
                v-model="userForm.email"
                :rules="emailRules"
              ></v-text-field>
            </v-flex>
            <v-flex xs12>
              <v-text-field
                :append-icon="userForm.showPassword ? 'visibility_off' : 'visibility'"
                :type="userForm.showPassword ? 'text' : 'password'"
                label="Initiales Passwort"
                v-model="userForm.password"
                :rules="passwordRules"
                @click:append="userForm.showPassword = !(userForm.showPassword)"
              ></v-text-field>
            </v-flex>
            <v-flex xs12>
              <v-select
                :items="roles"
                v-model="userForm.role"
                label="Rollen auswählen"
                :rules="mandatoryFieldRule"
                item-text="name"
                item-value="id"
                return-object
                required
              ></v-select>
            </v-flex>
            <v-flex xs12>
              <v-select
                :items="customers"
                v-model="userForm.customers"
                chips
                deletable-chips
                :item-value="customerValue"
                :item-text="customerText"
                return-object
                label="Kunden eingeben"
                multiple
              >
                <template v-slot:append-item
                >
                  <v-divider></v-divider>
                  <v-list-item
                    ripple
                    @click="loadNextCustomerPage"
                  >
                    <v-list-item-content>
                      <v-list-item-title>Weitere Kunden laden</v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                  <v-divider class="mt-2"></v-divider>
                </template>
              </v-select>
            </v-flex>
            <v-flex xs6>
              <v-text-field
                label="Vorname"
                v-model="userForm.firstName"
                :rules="mandatoryFieldRule"
              ></v-text-field>
            </v-flex>
            <v-flex xs6>
              <v-text-field
                label="Nachname"
                v-model="userForm.lastName"
                :rules="mandatoryFieldRule"
              ></v-text-field>
            </v-flex>
            <v-flex xs12>
              <v-text-field
                label="Straße"
                v-model="userForm.street"
                :rules="mandatoryFieldRule"
              ></v-text-field>
            </v-flex>
            <v-flex xs3>
              <v-text-field
                label="Postleitzahl"
                v-model="userForm.zipCode"
                :rules="zipCodeRules"
              ></v-text-field>
            </v-flex>
            <v-flex xs9>
              <v-text-field
                label="Stadt"
                v-model="userForm.city"
                :rules="mandatoryFieldRule"
              ></v-text-field>
            </v-flex>
          </v-layout>
        </v-container>
      </v-form>

      <v-card-actions class="hidden-sm-and-down">
        <v-spacer></v-spacer>
        <v-btn color="primary" text @click="close">Abbrechen</v-btn>
        <v-btn
          :disabled="!userForm.valid"
          :loading="loading"
          color="primary"
          text
          @click.native="createUser">
          Mitarbeiter anlegen
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
  import debounce from 'debounce'
  import _ from 'lodash'

  export default {
    name: 'NewUserDialog',
    props: ['show'],
    data () {
      return {
        page: 0,
        size: 50,
        userForm: {
          valid: false,
          showPassword: false,
          email: '',
          password: '',
          role: null,
          customers: [],
          firstName: '',
          lastName: '',
          street: '',
          zipCode: '',
          city: ''
        },
        mandatoryFieldRule: [
          v => !!v || 'Dieses Feld darf nicht leer sein'
        ],
        emailRules: [
          v => !!v || 'E-Mail nicht angegeben',
          v => /(.+)@(.+){2,}\.(.+){2,}/.test(v) || 'E-Mail hat nicht die korrekte Form. z.B.: beispiel@test.com'
        ],
        passwordRules: [
          v => !!v || 'Passwort nicht angegeben',
          v => (v && v.length >= 8) || 'Ein Passwort muss min. 8 Zeichen enthalten',
          v => /(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])/.test(v) || 'Passwort muss enthalten: - min. ein Kleinbuchstaben - min. ein Großbuchstaben - min. eine Ziffer'
        ],
        zipCodeRules: [
          v => !!v || 'Postleitzahl nicht angegeben',
          v => (v && v.length === 5) || 'Die Postleitzahl muss genau 5 Zeichen lang sein'
        ]
      }
    },
    computed: {
      loading: function () {
        return this.$store.getters.loading
      },
      customers: function () {
        return _.unionWith(this.userForm.customers.concat(this.$store.getters.customers), _.isEqual)
      },
      roles: function () {
        return this.$store.getters.roles
      },
      loadCustomers: function () {
        return debounce(this.fetchCustomers, 500)
      }
    },
    methods: {
      createUser () {
        this.$store.dispatch('addUser', this.userForm)
          .finally(() => this.close())
      },
      close () {
        this.clearForm()
        this.$emit('close')
      },
      clearForm () {
        this.userForm = initialState()
        this.$refs.form.reset()
      },
      loadNextCustomerPage () {
        this.page++
        this.fetchCustomers()
      },
      fetchCustomers () {
        this.$store.dispatch('loadCustomers', {
          searchTerms: ''.split(' '),
          page: this.page,
          size: this.size
        })
      },
      customerValue (item) {
        return item.id
      },
      customerText (item) {
        return item.lastName + ' ' + item.firstName + ' - ' + item.street + ', ' + item.city
      },
      remove (item) {
        const index = this.userForm.selectedCustomers.indexOf(item)
        if (index >= 0) this.userForm.selectedCustomers.splice(index, 1)
      }
    }
  }

  function initialState () {
    return {
      valid: false,
      showPassword: false,
      email: '',
      password: '',
      role: null,
      firstName: '',
      lastName: '',
      street: '',
      zipCode: '',
      city: ''
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Users/NewUserDialog.vue